import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext({ meta: null, refresh: () => {} });

export function MetaProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const refresh = async () => {
    try { const { data } = await api.get("/meta"); setMeta(data); } catch (_e) { /* ignore */ }
  };
  useEffect(() => { refresh(); }, []);
  return <Ctx.Provider value={{ meta, refresh }}>{children}</Ctx.Provider>;
}
export const useMeta = () => useContext(Ctx);
